const SALARY_COMPONENT_URLS = {
  GET_ALL: "/salary_components/get_all",
  INSERT: "/salary_components/insert",
  UPDATE: "/salary_components/update",
  GET_ONE: "/salary_components/get_one",
  DELETE: "/salary_components/delete_one",
  GET_ALL_SELECT: "/salary_components/get_all_select",
};

const LEAVE_TYPES_URLS = {
  GET_ALL: "/leave_types/get_all",
  INSERT: "/leave_types/insert",
  UPDATE: "/leave_types/update",
  GET_ONE: "/leave_types/get_one",
  DELETE: "/leave_types/delete_one",
  GET_ALL_SELECT: "/leave_types/get_all_select",
};

export { SALARY_COMPONENT_URLS, LEAVE_TYPES_URLS };
